import { enqueueSnackbar } from "notistack";
import holdFlightBooking from "../../../../controllers/booking/holdFlightBooking";

export async function manageOrderHoldFlightBooking(
  booking,
  loading,
  setLoading
) {
  setLoading({ ...loading, hold: true });
  const res = await holdFlightBooking(booking?._id).finally(() =>
    setLoading({ ...loading, hold: false })
  );
  if (res.return) {
    enqueueSnackbar(res.msg, { variant: "success" });
    setTimeout(() => {
      window.location.reload();
    }, 300);
  } else enqueueSnackbar(res.msg, { variant: "error" });
}
